import React from 'react';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import { ContentProps } from '../../newron-core';
import { Instructions } from '../../content/instructions';
import { AlertType } from './types';

const { Alert } = feedbackV2;

function AlertPanel({ instructions = {}, componentSettings }: ContentProps) {
  const myInstructions = new Instructions(instructions, componentSettings);
  const type = (myInstructions.getString('type') || 'info') as AlertType;
  const message = myInstructions.getString('message') || 'No message configured';

  return <Alert title={message} type={type} />;
}

export { AlertPanel };
